"use strict";

// NPM modules

var moment = require('moment');
var debug = false;

let {
	holidays,
	maxDate,
	minDate,
} = require('./holidays.js');

var maxDays = 365 * 2;

var answerCache = {};
var cacheHit = 0;
var cacheMiss = 0;

// Function

module.exports = function bizDays(d1, d2) {

	if (d1 === 'stats') {
		console.log("bizDays> hit: %s, miss: %s", cacheHit, cacheMiss);
		return;
	}

	// console.log('bizdays> CALL %s - %s', d1, d2);

	if (! d1) return 'invalid';	
	if (! d2) return 'invalid';
	
	var d1m = moment(d1, ['YYYY-MM-DD', 'MM-DD-YYYY']).startOf('day');
	if (! d1m.isValid()) return 'invalid';
	
	var d2m = moment(d2, ['YYYY-MM-DD', 'MM-DD-YYYY']).startOf('day');
	if (! d2m.isValid()) return 'invalid';
	
	if (d1m.isAfter(maxDate)) {
		if (debug) console.log("*** Invalid date: %s (Out of maximum range!)", d1m.format("YYYY-MM-DD"));
		return 'invalid';
	}

	if (d1m.isBefore(minDate)) {
		if (debug) console.log("*** Invalid date: %s (Out of minimum range!)", d1m.format("YYYY-MM-DD"));
		return 'invalid';
	}

	if (d2m.isAfter(maxDate)) {
		if (debug) console.log("*** Invalid date: %s (Out of maximum range!)", d2m.format("YYYY-MM-DD"));
		return 'invalid';
	}

	if (d2m.isBefore(minDate)) {
		if (debug) console.log("*** Invalid date: %s (Out of minimum range!)", d2m.format("YYYY-MM-DD"));
		return 'invalid';
	}
		
	var start;
	var end;
	var reverse = 1;
	
	if (d1m.isBefore(d2m)) {
		start = d1m;
		end = d2m;
	}
	else {
		start = d2m;
		end = d1m;
		reverse = -1;
	}
	
	// Check for cached answers

	var signature = `${start.format("YYYY-MM-DD")},${end.format("YYYY-MM-DD")}`;
	if (answerCache[signature]) {
		cacheHit += 1;
		return answerCache[signature];
	}
	
	cacheMiss += 1;
	
	var days = 0;
	while (start.isBefore(end)) {
		var isBizDay = false;
		var dayOfWeek = start.day();
		if ((dayOfWeek > 0) && (dayOfWeek < 6)) isBizDay = true; // Include weekdays
		if (holidays[start.format("YYYY-MM-DD")]) isBizDay = false; // Exclude holidays
		if (isBizDay) days += 1;
		
		// console.log("bizdays> %s / %s (%s)", start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"), days);
		
		start.add(1, 'd');
		
		if (days > maxDays) {
			if (debug) console.log("*** BizDays greater than %s", maxDays);
			answerCache[signature] = 'invalid';
			return 'invalid';
		}
	}
	
	var diff = days * reverse;
	// console.log("*** %s -> %s (diff=%s)", start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"), diff);
	
	answerCache[signature] = diff;
	return diff;

}




